import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { PartyTierDto } from '../../../config/finance/financeConfig'
import * as Yup from 'yup'
import FormikField from '../../Formik/FormikField'
import FormikMoneyField from '../../Formik/FormikMoneyField'
import LocalDatePicker, { LocalDatePickerProps } from '../../DatePicker/LocalDatePicker'

export const partyTierValidationSchema = (translate: (key: string) => string): Yup.ObjectSchema<any> => {
    return Yup.object().shape({
        validFrom: Yup.string().label(translate('party.edit.tier.validfrom')).nonNullable().required(),
        validTo: Yup.string().label(translate('party.edit.tier.validto')).nullable(),
        salesRate: Yup.string().label(translate('party.edit.tier.salesrate')).nonNullable().required(),
    })
}

export default function PartyTierFormContainer(): ReactElement {
    const { values, setFieldValue } = useFormikContext<PartyTierDto>()

    return (
        <>
            <FormikField<LocalDatePickerProps, PartyTierDto>
                orientation={'horizontal'}
                required
                labelKey={'party.edit.tier.validfrom'}
                fieldName={'validFrom'}
                component={LocalDatePicker}
                componentProps={{
                    isoValue: values.validFrom,
                    onSelectDate: newDate => setFieldValue('validFrom', newDate),
                    maxDate: values.validTo ? new Date(values.validTo) : undefined,
                }}
            />
            <FormikField<LocalDatePickerProps, PartyTierDto>
                orientation={'horizontal'}
                labelKey={'party.edit.tier.validto'}
                fieldName={'validTo'}
                component={LocalDatePicker}
                componentProps={{
                    isoValue: values.validTo,
                    onSelectDate: newDate => setFieldValue('validTo', newDate),
                    minDate: values.validFrom ? new Date(values.validFrom) : undefined,
                }}
            />

            <FormikMoneyField<PartyTierDto>
                orientation={'horizontal'}
                required
                labelKey={'party.edit.tier.salesrate'}
                fieldName={'salesRate'}
                currency={values?.currency}
                align={'end'}
                selectOnFocus
            />
        </>
    )
}
